module.exports = __webpack_public_path__ + "img/photo3_5.214f0247.jpg";